export const es_purpose = {
    purpose_title:'Vota o propone tu idea para mejorar Real Estate Pro. La idea que obtenga más votos será realizada primero.',
    purpose_alert:'Ooops! Puedes votar hasta 3 veces',
    purpose_sub:'PROPONE TU IDEA',
    purpose_desc:'Escribe tu idea abajo',
    purpose_invia:'Enviar',
   purpose_voti:'Votes',
   purpose_real:'Implementado!',
   purpose_vota:'Votar',




};